interface FieldWrapperThemeProps {
  captionFontCase?: 'uppercase' | 'lowercase' | 'capitalize' | 'none';
}

const FieldWrapper = {
  parts: ['caption'],
  baseStyle: ({ captionFontCase }: FieldWrapperThemeProps) => ({
    caption: {
      textTransform: captionFontCase,
    },
  }),
  variants: {},
  defaultProps: {},
};

export default FieldWrapper;
